(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

document.addEventListener('DOMContentLoaded', function () {
  var hamburger = document.querySelector('.header__hamburger');
  var spMenu = document.getElementById('spMenu');
  var spMenuClose = document.getElementById('spMenuClose');
  if (hamburger && spMenu) {
    hamburger.addEventListener('click', function () {
      spMenu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (spMenuClose && spMenu) {
    spMenuClose.addEventListener('click', function () {
      spMenu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  var spMenuItems = document.querySelectorAll('.sp-menu__nav-item, .sp-menu__form-btn');
  spMenuItems.forEach(function (item) {
    item.addEventListener('click', function () {
      if (spMenu) {
        spMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  });
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href === '#') return;
      var target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        var headerHeight = document.querySelector('.header').offsetHeight;
        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
  var scrollTopBtn = document.getElementById('scrollTop');
  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', function () {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  var gtStyleCSS = 'html { height: 100% !important; overflow: hidden !important; }' + 'body { height: 100% !important; overflow-y: auto !important; overflow-x: hidden !important; margin: 0 !important; }' + '.VIpgJd-ZVi9od-vH1Gmf { display: flex !important; flex-wrap: wrap !important; width: 100% !important; overflow: visible !important; height: auto !important; }' + 'a.VIpgJd-ZVi9od-vH1Gmf-ibnC6b, a.VIpgJd-ZVi9od-vH1Gmf-ibnC6b-gk6SMd { display: block !important; width: 50% !important; box-sizing: border-box !important; padding: 4px 10px !important; white-space: nowrap !important; overflow: hidden !important; text-overflow: ellipsis !important; font-size: 13px !important; line-height: 1.7 !important; }';
  var gtApplyFix = function gtApplyFix(iframe) {
    var doc = iframe.contentDocument;
    if (!doc || !doc.body) return false;
    var container = doc.querySelector('.VIpgJd-ZVi9od-vH1Gmf');
    if (!container) return false;
    var table = container.querySelector('table');
    if (!table) return false;
    if (table.style.display === 'none') return true;
    var links = table.querySelectorAll('a.VIpgJd-ZVi9od-vH1Gmf-ibnC6b, a.VIpgJd-ZVi9od-vH1Gmf-ibnC6b-gk6SMd');
    if (links.length === 0) return false;
    table.style.setProperty('display', 'none', 'important');
    var frag = doc.createDocumentFragment();
    links.forEach(function (link) {
      frag.appendChild(link);
    });
    container.appendChild(frag);
    if (!doc.getElementById('gt-dropdown-style')) {
      var style = doc.createElement('style');
      style.id = 'gt-dropdown-style';
      style.textContent = gtStyleCSS;
      doc.head.appendChild(style);
    }
    return true;
  };
  var gtTryFix = function gtTryFix(iframe) {
    if (gtApplyFix(iframe)) return;
    var poll = setInterval(function () {
      if (gtApplyFix(iframe)) clearInterval(poll);
    }, 100);
    setTimeout(function () {
      clearInterval(poll);
    }, 5000);
  };
  var gtObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'IFRAME' && node.classList.contains('VIpgJd-ZVi9od-xl07Ob-OEVmcd')) {
          node.addEventListener('load', function () {
            gtTryFix(node);
          });
          gtTryFix(node);
          var attrObserver = new MutationObserver(function () {
            if (node.style.display !== 'none') {
              gtTryFix(node);
            }
          });
          attrObserver.observe(node, {
            attributes: true,
            attributeFilter: ['style']
          });
        }
      });
    });
  });
  gtObserver.observe(document.body, {
    childList: true
  });
  var stepper = document.getElementById('contactStepper');
  var instructions = document.getElementById('contactInstructions');
  if (stepper) {
    var steps = stepper.querySelectorAll('.contact-page__step');
    var mwForm = document.querySelector('.mw_wp_form');
    var currentStep = 1;
    if (mwForm) {
      if (mwForm.classList.contains('mw_wp_form_confirm')) {
        currentStep = 2;
      } else if (mwForm.classList.contains('mw_wp_form_complete')) {
        currentStep = 3;
      }
    }
    steps.forEach(function (step) {
      step.classList.remove('is-active');
      var stepNum = parseInt(step.getAttribute('data-step'), 10);
      if (stepNum === currentStep) {
        step.classList.add('is-active');
      }
    });
    if (instructions) {
      if (currentStep === 2) {
        instructions.innerHTML = '入力内容をご確認の上、<br />「送信する」ボタンを押してください。';
      } else if (currentStep === 3) {
        instructions.innerHTML = 'お問い合わせが完了しました。';
      }
    }
  }
});

},{}]},{},[1]);
